export const BUSINESS_DOCUMENT_UPLOAD = 'BUSINESS_DOCUMENT_UPLOAD'
export const BANK_DOCUMENT_UPLOAD = 'BANK_DOCUMENT_UPLOAD'
export const CAC_DOCUMENT_UPLOAD = 'CAC_DOCUMENT_UPLOAD'
export const REG_STEP = 'REG_STEP'
